import WorkflowsForm from "../components/workflows-form";

export default <template>
  <div class="workflows-form-page">
    <WorkflowsForm @model={{@model}} />
  </div>
</template>
